export default __webpack_public_path__ + "static/media/small_twitter_line.dd13efff.svg";